/**
 * Utility functions for checking refund transaction states
 */

export const isRefundTransactionCompleted = (transaction: any): boolean =>
  transaction?.__typename === 'CompletedRefundTransaction'

export const isRefundTransactionError = (transaction: any): boolean =>
  transaction?.__typename === 'FailedRefundTransaction'

export const isRefundTransactionProcessing = (transaction: any): boolean =>
  transaction?.__typename === 'PendingRefundTransaction'
